import { graphql } from '../../../gql';

export const GET_SENTIMENT_MAP_QUERY = graphql(`
  query getSentimentMap($postId: String!) {
    getPostById(postId: $postId) {
      id
      sentimentMap {
        sentimentG
        agreementG
        nReplies
        nVotes
        nNegative
        nNeutral
        nPositive
        computedAt
        regions {
          level
          path
          sentiment
          sentimentVar
          agreement
          nReplies
          nVotes
          nNegative
          nNeutral
          nPositive
          isOpposite
          isLocalConsensus
        }
      }
    }
  }
`);
